namespace GeniuzPOS.Purchase {
    export interface ReportPurTaxForm {
        Lineitemno: Serenity.IntegerEditor;
        TaxInvoiceDate: Serenity.DateEditor;
        TaxInvoiceNo: Serenity.StringEditor;
        SupplName: Serenity.StringEditor;
        SupplTaxId: Serenity.StringEditor;
        NetAmt: Serenity.DecimalEditor;
        VatAmt: Serenity.DecimalEditor;
        TotalAmt: Serenity.DecimalEditor;
    }

    export class ReportPurTaxForm extends Serenity.PrefixedContext {
        static formKey = 'Purchase.ReportPurTax';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ReportPurTaxForm.init)  {
                ReportPurTaxForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.DateEditor;
                var w2 = s.StringEditor;
                var w3 = s.DecimalEditor;

                Q.initFormType(ReportPurTaxForm, [
                    'Lineitemno', w0,
                    'TaxInvoiceDate', w1,
                    'TaxInvoiceNo', w2,
                    'SupplName', w2,
                    'SupplTaxId', w2,
                    'NetAmt', w3,
                    'VatAmt', w3,
                    'TotalAmt', w3
                ]);
            }
        }
    }
}
